import { createAction } from "@ngrx/store";

export const upgraded = createAction("[App] upgraded");
